import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { TbSearch } from "react-icons/tb";
import { CgShoppingCart } from "react-icons/cg";
import { AiOutlineHeart } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";

import { Link } from "react-router-dom";
import "./Header.scss";
import Search from "./Search/Search";
import { Context } from "../../utils/context";
import Cart from "../Cart/Cart";

import Wishlist from "../Wishlist/Cart";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logoutuser } from "../../utils/feature/userSlice";

import logo4 from "../../assets/logo4.png";
import Megamenu from "./Megamenu";
import SubHeader from "./SubHeader";
import axios from "axios";
import { BASE_URL } from "../../utils/BaseURL";

const Header = () => {
  const { cartCount, showCart, showWishlist, cartItems } = useContext(Context);
  const [scrolled, setScrolled] = useState(false);
  const [searchModal, setSearchModal] = useState(false);
  const [usermodel, setUserModal] = useState(false);
  const userData = JSON.parse(localStorage.getItem("user")) || {};
  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    if (userData?.success && userData?.user) {
      const fullName = userData?.user?.name;
      setFirstName(fullName.split(" ")[0]);
    }
  }, [userData]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleDropdownToggle = () => {
    const dropdown = document.getElementById("dropdown");
    dropdown.classList.toggle("hidden");
  };
  const [searchValue, setSearchValue] = useState(""); // Initialize state variable

  const handleInputChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value); // Update the state with the input value
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(`category/${searchValue}`); // Use the updated value in the navigation
  };

  return (
    <>
      <header
        className={`main-header ${scrolled ? "sticky top-0 left-0" : ""}`}
      >
        <div className="header-content overflow-hidden  ">
          <Link to="/" className="let flex">
            {/* <img className=" relative right-8 top-0 w-40 md:w-56" src={logo} alt="" /> */}
            <img
              className=" relative right-8 top-1    w-40 md:w-56"
              src={logo4}
              alt=""
            />
          </Link>

          <div className="center" onClick={() => navigate("/")}>
            <div className="items-center hidden md:flex">
              <Megamenu />
              <form
                onSubmit={handleSubmit}
                className="flex border border-purple-200 rounded"
              >
                {/* <div><SubHeader/></div> */}
                <input
                  type="text"
                  className="block w-[360px] px-4 py-2 text-purple-700 bg-white border  focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40 text-sm"
                  placeholder="Search..."
                  value={searchValue} // Set the input value from the state
                  onChange={handleInputChange} // Handle input change
                />
                <button
                  type="submit"
                  className="px-4 text-white bg-purple-600 border-l rounded text-sm"
                >
                  Search
                </button>
              </form>
            </div>
          </div>
          <div className="right">
            <div className="block md:hidden">
              <TbSearch onClick={() => setSearchModal(true)} />
            </div>
            <span
              // onClick={()=>setShowWishlist(true)}
              onClick={() => navigate("wishlist")}
              className="cart-icon"
            >
              <AiOutlineHeart />
            </span>
            <span
              className="cart-icon"
              // onClick={() => setShowCart(true)}
              onClick={() => navigate("checkout")}
            >
              <CgShoppingCart />
              {!!cartCount && <span>{cartCount}</span>}
            </span>
            <div onClick={() => setUserModal(!usermodel)}>
              <AiOutlineUser />
            </div>
          </div>
        </div>
      </header>
      {searchModal && <Search setSearchModal={setSearchModal} />}
      {showCart && <Cart />}
      {showWishlist && <Wishlist />}

      {!usermodel ? (
        ""
      ) : (
        <div
          className="z-50 user-menu  absolute top-20 right-10    lg:right-20 bg-white  p-4 rounded   shadow-2xl"
          style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
        >
          <div className="mb-3">
            <h4 className="text-xl font-bold mb-2">
              Welcome, {firstName || "Guest"}
            </h4>
          </div>
          {userData?.success ? (
            <div>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/profile"
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Profile
                  </Link>
                </li>
                <li>
                  <Link
                    to="/orders"
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Orders
                  </Link>
                </li>
              </ul>
              <button
                className="block w-full text-center py-2 px-4 mt-4 bg-blue-500 text-white font-bold rounded hover:bg-blue-700"
                onClick={() => {
                  dispatch(logoutuser());
                  navigate("/login");
                  setUserModal(false);
                }}
              >
                Logout
              </button>
            </div>
          ) : (
            <div>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/login"
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Login
                  </Link>
                </li>
                <li>
                  <Link
                    to="/signup"
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Signup
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Header;
